import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchHoofdleidingContextLists,
  initialState,
} from '../services/fetchHoofdleidingContextLists'

export { useHoofdleidingContextLists, queryKey }

// Prefix of the keys of all contexts; depends on the projectbetrokkenen and labels, so mutating those must invalidate it
const queryKey = ['valuelists-hoofdleiding', 'context']

const useHoofdleidingContextLists = ({
  gebiedscode,
  verantwoordelijke,
}: {
  gebiedscode?: string
  verantwoordelijke?: string
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () =>
      fetchHoofdleidingContextLists({
        gebiedscode: gebiedscode as string,
        verantwoordelijke,
      }),
    queryKey: [...queryKey, gebiedscode, verantwoordelijke],
    enabled: hasPermissions && !!gebiedscode,
  })

  return {
    data: data || initialState.data,
  }
}
